import { Space } from "antd";
import styled from "styled-components";

export const SpaceWithFullWidth = styled(Space)`
  width: 100%;
`;
